import { render } from "./activeType.vue?vue&type=template&id=5576432c"
import script from "./activeType.vue?vue&type=script&lang=js"
export * from "./activeType.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/brandProduct/components/activeType.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5576432c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5576432c', __exports__)) {
    console.log('reload')
    api.reload('5576432c', __exports__)
  }
  
  module.hot.accept("./activeType.vue?vue&type=template&id=5576432c", () => {
    console.log('re-render')
    api.rerender('5576432c', render)
  })

}


export default __exports__